import { NgModule } from '@angular/core';

import { BreadcrumbIqbaService } from './breadcrumbIqba.service';
import { BreadcrumbServiceModule } from "libraries/service/breadcrumb/breadcrumbService.module";

@NgModule({
    imports: [BreadcrumbServiceModule],
    providers: [
        BreadcrumbIqbaService,
    ],
})
export class BreadcrumbIqbaModule {}